import { createElement, ReactNode } from 'react';

import { GenericProviderProps } from ':cloud/types/ts_types';

type ComposeProvidersProps = {
  providers: ((props: GenericProviderProps) => ReactNode)[];
  children: ReactNode;
};

export function ComposeProviders({ providers = [], children }: ComposeProvidersProps) {
  return (
    providers.length <= 0
      ? children
      : providers.reduce((acc, curr) => createElement(curr as any, [], acc), children)
  ) as JSX.Element;
}
